export function notifyError(errorString: string): void  {
  if (import.meta.env.VITE_ENV_VARIABLE != 'development') {
    const enc = new TextEncoder()
    const errorEncoded = enc.encode(errorString)
    navigator.sendBeacon('/api/error-logging.php', errorEncoded)
  }
}
